import React, { useEffect, useState } from "react";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Offcanvas,
  Modal,
} from "react-bootstrap";
import ParkingImage from "../../../style/Img/Parcheggi/Maps.jfif";

function ListaParcheggi() {
  let history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  let [id, setId] = useState("");

  const [valore, setValore] = useState(0);

  const eliminaParcheggio = () => {
    const data = { id: id };
    axios
      .post(
        `https://website-8bit-motors.herokuapp.com/parcheggi/rimuoviParcheggio`,
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          setShowModal(false);
          history.go(0);
        }
      });
  };

  const [listaParcheggi, setListaParcheggi] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://website-8bit-motors.herokuapp.com/parcheggi/ottieniParcheggi"
      )
      .then(function (response) {
        setListaParcheggi(response.data);
      });
  }, []);

  return (
    <>
      <Container fluid className="text-center">
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>

        <Container>
          <Fade left>
            <h2 align="center" className="mt-2">
              <strong>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-bank"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 .95 14.61 4h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.379l.5 2A.5.5 0 0 1 15.5 17H.5a.5.5 0 0 1-.485-.621l.5-2A.5.5 0 0 1 1 14V7H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 4h.89L8 .95zM3.776 4h8.447L8 2.05 3.776 4zM2 7v7h1V7H2zm2 0v7h2.5V7H4zm3.5 0v7h1V7h-1zm2 0v7H12V7H9.5zM13 7v7h1V7h-1zm2-1V5H1v1h14zm-.39 9H1.39l-.25 1h13.72l-.25-1z" />
                </svg>{" "}
                Lista Parcheggi{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-bank"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 .95 14.61 4h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.379l.5 2A.5.5 0 0 1 15.5 17H.5a.5.5 0 0 1-.485-.621l.5-2A.5.5 0 0 1 1 14V7H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 4h.89L8 .95zM3.776 4h8.447L8 2.05 3.776 4zM2 7v7h1V7H2zm2 0v7h2.5V7H4zm3.5 0v7h1V7h-1zm2 0v7H12V7H9.5zM13 7v7h1V7h-1zm2-1V5H1v1h14zm-.39 9H1.39l-.25 1h13.72l-.25-1z" />
                </svg>
              </strong>
            </h2>
          </Fade>

          <Zoom>
            <Container fluid>
              <Row>
                {listaParcheggi.map((value, key) => {
                  return (
                    <>
                      <Col className="col-lg-4">
                        <Card
                          key={key}
                          className="mt-2"
                          style={{ width: "18rem" }}
                        >
                          <Card.Img variant="top" src={ParkingImage} />
                          <Card.Body>
                            <Card.Title>
                              Parcheggio {value.nome_parcheggio}
                            </Card.Title>
                            <Card.Text>
                              <h5>Luogo:</h5>
                              <p>{value.luogo}</p>
                            </Card.Text>
                            <Button
                              onClick={() => {
                                setShowModal(true);
                                setValore(key);
                                setId(listaParcheggi[key].id);
                              }}
                              variant="danger"
                            >
                              Rimuovi Parcheggio
                            </Button>
                            <Button
                              variant="info"
                              className="mt-2"
                              onClick={() => {
                                setShow(true);
                                setValore(key);
                              }}
                            >
                              Maggiori Informazioni
                            </Button>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Offcanvas show={show} onHide={handleClose}>
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Parcheggio {listaParcheggi[valore].nome_parcheggio}
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <h3>Luogo:</h3>
                          <p>{listaParcheggi[valore].luogo}</p>
                          <h3>Orario di Apertura:</h3>
                          <p>{listaParcheggi[valore].orario_apertura}</p>
                          <h3>Orario di Chiusura:</h3>
                          <p>{listaParcheggi[valore].orario_chiusura}</p>
                        </Offcanvas.Body>
                      </Offcanvas>

                      <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Rimuovi Parcheggio{" "}
                            {listaParcheggi[valore].nome_parcheggio}{" "}
                            {listaParcheggi[valore].cognome}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Sei sicuro di volere rimuovere il parcheggio{" "}
                          {listaParcheggi[valore].nome_parcheggio}? QUESTA
                          AZIONE È IRREVERSIBILE!
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="success" onClick={handleClose}>
                            Annulla
                          </Button>
                          <Button variant="danger" onClick={eliminaParcheggio}>
                            Rimuovi
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  );
                })}
              </Row>
            </Container>
          </Zoom>
        </Container>

        <Button
          variant="dark"
          className="mt-3"
          onClick={() => {
            history.push("/amministratore/aggiungiParcheggio");
          }}
        >
          Aggiungi Parcheggio
        </Button>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Container>
    </>
  );
}

export default ListaParcheggi;
